/**
 * getTimeZoneFormatted returns formatted current time zone
 * @param timeZoneOffset {Number} time zone as a number
 * @returns formatted time zone {String} string representation of the current time zone
 */
import { getTimeZoneSign } from "../TimeZoneSignHelper";
var cache = {};
export function getTimeZoneFormatted(timeZoneOffset) {
    if (!cache[timeZoneOffset]) {
        var timeZoneSign = getTimeZoneSign(timeZoneOffset);
        var timeZone = (timeZoneOffset !== 0) ? timeZoneSign + timeZoneOffset : "";
        cache[timeZoneOffset] = "(GMT" + timeZone + ")";
    }
    return cache[timeZoneOffset];
}
//# sourceMappingURL=TimeZoneFormatter.js.map